const pxcWidgetConsts = {
  INITIALISATION: 'INITIALISATION',
  AUTHENTICATION: 'Authentication',
  TRANSACTION: 'Transaction',
};

export default pxcWidgetConsts;
